import { MonitorPlay, Cast, CalendarCheck, Users, Download, MessagesSquare } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/landing/Reveal";

const FEATURES = [
  { icon: MonitorPlay, title: "Video Workouts", desc: "Easy-to-follow videos for every workout in the app — just press play and follow Bryan." },
  { icon: Cast, title: "Stream Anywhere", desc: "Stream to your TV or laptop with AirPlay, Chromecast, Fire TV Stick, and Cast2Web." },
  { icon: CalendarCheck, title: "Tracking", desc: "Track your progress workout by workout and share your wins straight to Instagram." },
  { icon: Users, title: "Community", desc: "Connect with supportive, real people on the exact same journey as you." },
  { icon: Download, title: "Offline Downloads", desc: "Work out anywhere — even without an internet connection." },
  { icon: MessagesSquare, title: "DMs", desc: "Chat directly and effortlessly when you need a nudge or have a question." },
];

export const AppFeatures = () => (
  <section id="features" data-testid="features-section" className="py-24 md:py-32 bg-slate-950 scroll-mt-20">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <SectionHeading label="Everything included" title="One app. Every tool you need." sub="Your free trial unlocks the full app — nothing is locked behind a paywall once you're in." />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
        {FEATURES.map((f, i) => (
          <Reveal key={f.title} delay={0.06 * i}>
            <div data-testid={`feature-item-${i}`}>
              <span className={`inline-flex w-12 h-12 rounded-2xl items-center justify-center mb-5 ${i % 2 ? "bg-orange-500/15 text-orange-400" : "bg-blue-500/15 text-blue-400"}`}>
                <f.icon size={23} />
              </span>
              <h3 className="font-display text-xl font-bold text-white mb-2">{f.title}</h3>
              <p className="text-sm sm:text-base text-slate-400 leading-relaxed">{f.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
